import './assets/css/custom.scss';

let render = () => {
    require('./AppRenderer');
};

render();
